import { Anchor, createStyles, Group } from '@mantine/core';
import { Text } from '@repo/foundations';

const useStyles = createStyles((theme) => ({
	link: {
		color: theme.other.getColor('text/emphasis/default'),
		fontSize: theme.fontSizes.sm,
		textDecoration: 'underline',

		'&:hover, &:focus, &:active': {
			color: theme.other.getColor('text/emphasis/hover'),
		},
	},
}));

export function AuthTermsAndPolicy() {
	const { classes } = useStyles();

	return (
		<Group spacing={0} align="center" position="center">
			<Text size="sm" color="text/secondary/default">
				By proceeding, you agree to Secoda’s
			</Text>
			<Text size="sm" color="text/secondary/default">
				<Anchor
					target="_blank"
					href="https://docs.secoda.com/policies/terms-of-use"
					className={classes.link}
				>
					Terms of Use
				</Anchor>{' '}
				and{' '}
				<Anchor
					target="_blank"
					href="https://docs.secoda.com/policies/privacy-policy"
					className={classes.link}
				>
					Privacy Policy
				</Anchor>
			</Text>
		</Group>
	);
}
